import { GetterTree } from 'vuex'
import orderBy from 'lodash/orderBy'

import { TechpacksState, TechpackRowItem } from './techpacks.model'

export enum GetterTypes {
  GET_FOLDER_TECHPACKS = 'GET_FOLDER_TECHPACKS'
}

interface Getters {
  [GetterTypes.GET_FOLDER_TECHPACKS](state: TechpacksState): (a: string) => Array<TechpackRowItem>
}

export const getters: GetterTree<TechpacksState, unknown> & Getters = {
  [GetterTypes.GET_FOLDER_TECHPACKS](state): (a: string) => Array<TechpackRowItem> {
    return (folderId: string): Array<TechpackRowItem> => {
      return orderBy(state.techpacks[folderId], 'addedAt', 'desc') || []
    }
  }
}
